import angular from 'angular';

import '../../../../services/user';

angular.module('folkeuni').component('navigationProfile', {
  templateUrl: '/shop-dist/templates/navigation-profile.html',
  bindings: {
    departmentId: '@',
    newPasswordUrl: '@',
    myPageUrl: '@',
    userCreateUrl:'@'
  },
  controller: function(User) {
    var $ctrl = this;
    $ctrl.currentUser = null;
    $ctrl.loading = false;

    $ctrl.$onInit = function() {

      User.getCurrent().then(function(userObj) {
        $ctrl.userCurrent = userObj;
      }, function(errorResponse) {
        $ctrl.loading = false;
      });
    }
  },
  transclude: true
});
